export default __webpack_public_path__ + "static/media/svg-3.a32fc278.svg";